/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import ArrayProxy from '@ember/array/proxy';
import CategoryModel from 'cio/models/category';
import SavedRowModel from 'cio/models/saved-row';
import { SortDirection } from 'cio/utils/sort';
import { SortProperty } from 'cio/components/manage-saved-rows-modal';
import { SavedRowProxy } from 'cio/components/manage-saved-rows-modal/saved-rows-table/edit-form';

interface SavedRowsTableArgs {
  hasPendingInteraction: boolean;
  savedRows: ArrayProxy<SavedRowModel>;
  sortBy: SortProperty;
  sortDirection: SortDirection;
  categories?: ArrayProxy<CategoryModel>;
  rowPendingDeletion?: SavedRowModel;
  rowPendingEdit?: SavedRowModel;
  disabled: boolean;
  onSort: (property: SortProperty, direction: SortDirection) => unknown;
  onDelete: (row: SavedRowModel) => unknown;
  onEdit: (row: SavedRowModel) => unknown;
  onCancelDelete: (row: SavedRowModel) => unknown;
  onCancleEdit: (row: SavedRowModel) => unknown;
  onConfirmDelete: (row: SavedRowModel) => unknown;
  onConfirmEdit: (rowProxy: SavedRowProxy) => unknown;
}

export default class SavedRowsTable extends Component<SavedRowsTableArgs> {
  @tracked hasFailedToDelete = false;

  headers = [
    {
      buttonClasses: 'h-[44px] pl-3 py-0 pr-1',
      label: 'Name',
      value: SortProperty.Name,
    },
    {
      buttonClasses: 'h-[44px] px-1 py-0',
      label: 'Category',
      value: SortProperty.Category,
    },
  ];
}
